/**
 * Generate a unique "(copy)" suffix for a duplicated process name.
 *
 * Strips any existing `(copy)` / `(copy 2)` suffix off the base so we don't
 * pile them up (e.g. duplicating "Foo (copy)" lands on "Foo (copy)" again
 * rather than "Foo (copy) (copy)"), then appends `(copy)`. If that name
 * already exists in `existing`, walks `(copy 2)`, `(copy 3)`, ... until
 * it finds a free slot.
 *
 * Shared between the side-panel rename-style duplicate dialog (where the
 * user can edit the suggested name) and the canvas-toolbar confirmation
 * dialog (where the suggestion IS the new name and the user just confirms).
 */
export const suggestCopyName = (
  base: string,
  existing: readonly string[] = [],
): string => {
  const cleanBase = base.replace(/\s+\(copy(?:\s+\d+)?\)$/i, '');
  const lower = (s: string) => s.trim().toLowerCase();
  const taken = new Set(existing.map(lower));
  let candidate = `${cleanBase} (copy)`;
  let n = 2;
  while (taken.has(lower(candidate))) {
    candidate = `${cleanBase} (copy ${n})`;
    n++;
  }
  return candidate;
};
